import { useState, Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import apiService from '../../services/apiServices';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { useParams } from 'react-router-dom';

const STATUSES = [
  { id: 0, name: '' },
  { id: 1, name: 'aktiv' },
  { id: 2, name: 'inaktiv' },
];

export default function EditDepartment(props) {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  let { id } = useParams();
  useEffect(() => {
    apiService()
      .query('getDepartment', 'id=' + id)
      .then((response) => {
        if (response.success) {
          const payload = response.data[0] || {};
          setValue('Id', payload.Id ?? payload.id);
          setValue('Name', payload.Name ?? payload.name ?? '');
          setValue(
            'ShortName',
            payload.ShortName ??
              payload.short_name ??
              payload.Short ??
              payload.short ??
              ''
          );
          setValue(
            'Status',
            STATUSES.find(function (e) {
              return e.id === (payload.Status ?? payload.status);
            }) || STATUSES[0]
          );
        }
      });
  }, [id, setValue]);

  const onSubmit = (data) => {
    const statusId = data?.Status?.id ?? data?.Status;
    if (statusId !== undefined) {
      data.Status = statusId;
    }
  console.log(data);
  apiService()
    .put('department', data)
    .then((response) => {
      if (response.success) {
        setToast({
          open: true,
          message: 'U ruajten me sukses!',
          variant: 'success',
        });
      } else {
        setToast({
          open: true,
          message: 'Ka ndodhur nje gabim!',
          variant: 'error',
        });
      }
    });
};
  //console.log(defaultValues);
  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/dashboard/adddepartment"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Department Data
            </Typography>
            <form>
              <Grid container spacing={3}>
                <TextField
                  sx={{ display: 'none' }}
                  variant="outlined"
                  id="id"
                  name="Id"
                  {...register('Id')}
                  value={id}
                />
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Emri i Departamentit"
                    error={errors.Name}
                    control={control}
                    name="Name"
                    register={{ ...register('Name') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Inicialet"
                    error={errors.ShortName}
                    control={control}
                    name="ShortName"
                    register={{ ...register('ShortName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <SelectController
                    placeholder="Statusi"
                    error={errors.Status}
                    control={control}
                    options={STATUSES}
                    name="Status"
                    register={{ ...register('Status') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
